<template>
  <btn-ver-localizacao
    :cliente="{ latitude: pedido.latitude, longitude: pedido.longitude }" 
  >
    <v-icon left>mdi-map-marker-outline</v-icon>
    <small>{{ pedido.cidade_entrega }}</small>
  </btn-ver-localizacao>
</template>

<script>
import BtnVerLocalizacao from "../clientes/BtnVerLocalizacao.vue";
export default {
  props: {
    pedido: Object,
  },
  components: { BtnVerLocalizacao },
};
</script>

<style>
</style>